import { BASE_URL } from 'config/urls';

import { callUrl, get } from 'utils/sdk';

export const getUpcomingMeetings = (params) =>
  callUrl(get, `${BASE_URL}/v1/meetings/upcoming/`, params);

export const fetchTeams = (params) =>
  callUrl(get, `${BASE_URL}/v1/meetings/teams/`, params);
